import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-sage-soft" data-id="element-136" data-mp="1o3dmwcdeadr5">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-137" data-mp="2223ljwfv4lhm">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-white text-sage-deep shadow-card ring-4 ring-sage/40" data-id="element-138" data-mp="1x42054uysa2z">
          <span className="font-display text-4xl font-semibold leading-none" data-id="element-139" data-mp="19co4oq1inyds">7</span>
          <span className="text-xs font-bold" data-id="element-140" data-mp="14hh8e3aktvyw">days</span>
        </div>
        <p className="mt-6 text-sm font-semibold text-sage-deep" data-id="element-141" data-mp="1j5lt1ct6whkb">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-142" data-mp="1edbw3ctnqh8j">
          Open everything. <span className="wash-text" data-id="element-143" data-mp="qmydse0vjwr5">Run a session from it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-navy-soft" data-id="element-144" data-mp="lpy6jzsagnyg">
          Read the volumes, print a worksheet, run a session straight from the
          page. If 52 Weeks of Art-Based Sessions doesn&apos;t change how you
          plan your sessions, email us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-145" data-mp="yqmfbtk843s4">
          {chips.map(chip => <li key={chip} className="rounded-full bg-white px-4 py-2 text-[13px] text-navy-soft" data-id="element-146" data-mp="12qeq8cx3am0n">{chip}</li>)}
        </ul>
      </div>
    </section>;
}